"use client";

import { type ReactNode } from "react";

import { cn } from "../../utils";
import { useRadioGroupRootContext } from "./context";
import { labelStyles } from "./style";

export interface RadioGroupDescriptionProps {
  children?: ReactNode;
  disabled?: boolean;
}

export const Description = (props: RadioGroupDescriptionProps) => {
  const { size } = useRadioGroupRootContext();

  return (
    <p
      className={cn(
        labelStyles({ size }),
        "font-normal text-neutral-60 group-aria-disabled:cursor-not-allowed group-aria-disabled:text-neutral-80"
      )}
    >
      {props.children}
    </p>
  );
};
